// Angular Files
import {
 Component, Input, Output, EventEmitter, OnInit
} from '@angular/core';

// Teller Online Library Files
import { TellerOnlineAppService } from 'libraries/core/src/lib/services/app.service';
import { TellerOnlineSiteMetadataService } from 'libraries/core/src/lib/services/site-metadata.service';

// Service interfaces for optional injection
export interface AuthServiceInterface {
    isSignedIn: boolean;
}

export interface MenuItemInterface {
    menuItemId?: number;
    pageId: number | null;
    label: string;
    description?: string;
    active?: boolean;
}

export interface PageInterface {
    id: number;
    header: string;
    active?: boolean;
}

export interface EditChangeEvent {
    field: string;
    value?: string;
    index?: number;
    event?: any;
    direction?: 'up' | 'down' | 'left' | 'right';
}

@Component({
    selector: 'public-welcome',
    templateUrl: './public-portal-welcome.component.html',
    styleUrls: ['./public-portal-welcome.component.scss'],
    host: {
        class: 'welcome-view'
    },
    standalone: false
})
export class PublicPortalWelcomeComponent implements OnInit {
    @Input() preview: boolean = false;

    @Input() title?: string;

    @Input() subtitle?: string;

    @Input() homeBannerContent?: string;

    @Input() menuItems?: MenuItemInterface[];

    @Input() inactiveMenuItems?: MenuItemInterface[];

    @Input() pages?: PageInterface[];

    @Input() authenticationEnabled?: boolean;

    @Input() siteMetadataService?: TellerOnlineSiteMetadataService;

    @Input() authService?: AuthServiceInterface;

    @Input() appService?: TellerOnlineAppService;

    // Edit mode inputs
    @Input() editMode: boolean = false;

    @Input() titleError: boolean = false;

    @Input() menuItemLabelErrors: boolean[] = [];

    @Input() menuItemPageIdErrors: boolean[] = [];

    @Output() editChange = new EventEmitter<EditChangeEvent>();

    ngOnInit() {
        if (this.appService && !this.preview) {
            this.appService.finishPageLoading();
        }
    }

    get siteMetadata() {
        return this.siteMetadataService || null;
    }

    /** Preview renders the site as configured rather than as flagged, so the editor still sees
     * every action card. */
    isPageUnderMaintenance(pageId: number): boolean {
        if (this.preview) return false;

        return this.siteMetadata?.isPageUnderMaintenance(pageId) ?? false;
    }

    /**
     * Get page options formatted for the inline edit dropdown
     */
    get pageDropdownOptions(): { value: string | null; label: string }[] {
        if (!this.pages || this.pages.length === 0) {
            return [];
        }
        return this.pages.map(page => ({
            value: page.id != null ? String(page.id) : null,
            label: page.header
        }));
    }

    /**
     * Get the page label for a given pageId
     */
    getPageLabel(pageId: number | null): string {
        if (pageId == null || !this.pages) {
            return 'Select a page...';
        }
        const page = this.pages.find(p => p.id === pageId);
        return page?.header || 'Unknown page';
    }

    /**
     * Convert pageId to string for use in linkEditValue (HTML select elements use strings)
     */
    getPageIdAsString(pageId: number | null): string {
        return pageId != null ? String(pageId) : '';
    }
}
